import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { LiabilitiesDelagateConfirmationModel } from 'src/app/shared/models/liabilities-delagate-confirmation.model';

@Component({
standalone: false,
  selector: 'app-delete-biller-sub-account-delegation-confirmation-dialog',
  templateUrl: './delete-biller-sub-account-delegation-confirmation-dialog.component.html',
  styleUrls: ['./delete-biller-sub-account-delegation-confirmation-dialog.component.scss'],
})
export class DeleteBillerSubAccountDelegationConfirmationDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: LiabilitiesDelagateConfirmationModel) {}
}
